<template>
  <a-modal v-model="modal" title="请选择排产组织" width="450px" :maskClosable="false" :closable="false">
    <a-form-model :model="formData" ref="form">
      <a-form-model-item
        label="请选择排产组织"
        :labelCol="{ style: 'width: 120px;float:left' }"
        :wrapperCol="{ style:'width:calc(100% - 120px ) !important;float:left'}"
        prop="orgNos"
        :rules="rules.orgNos"
      >
        <global-select
          :dropdown-match-select-width="false"
          v-model="formData.orgNos"
          selectType="selectMultipleFilter"
          :setParams="{ organizationCode: organizationCodeOrigin }"
          @change="changeOrgNos"
          requestApi="/scp/scpProductionScheduling/listPcOrg"
          :selectItem="{ value: 'realValue', label: 'label' }"
        />
      </a-form-model-item>
      <a-form-model-item
        label="车间"
        :labelCol="{ style: 'width: 120px;float:left' }"
        :wrapperCol="{ style:'width:calc(100% - 120px ) !important;float:left'}"
        prop="workshopCodes"
      >
        <a-select v-model="formData.workshopCodes" option-filter-prop="children" option-label-prop="label" mode="multiple" :max-tag-text-length="2" :max-tag-count="1">
          <a-select-option v-for="(item) in workshopCodeList" :key="item.workshopCode" :value="item.workshopCode" :label="item.workshopCode">
            {{ item.workshopCode }}-{{ item.workshopDesc }}
          </a-select-option>
        </a-select>
      </a-form-model-item>
    </a-form-model>
    <template #footer>
      <a-space>
        <a-button @click="modal=false;$refs.form.resetFields();">取消</a-button>
        <a-button type="primary" @click="submit" :loading="loading">确定</a-button>
      </a-space>
    </template>
  </a-modal>
</template>

<script>
import { productionSchedulingPc } from '@/api/scp/productionScheduling/schedulingWorkbench'
import { apiBomWorkshopFindList } from '@/api/mes/basedata/factoryAssembly'
import { mapState } from 'vuex'

export default {
  name: 'ScheduleOrgModal',
  data() {
    return {
      workshopCodeList: [], // 车间编码
      modal: false,
      formData: { orgNos: undefined, workshopCodes: undefined },
      loading: false,
      rules: {
        orgNos: [{ required: true, message: ' ', trigger: 'change' }]
      }
    }
  },
  computed: {
    ...mapState({
      organizationCodeOrigin: (state) => state.user.organizationCode
    })
  },
  methods: {
    changeOrgNos () {
      this.formData.workshopCodes = undefined
      this.getBomWorkshopFindList()
    },
    // 车间编码
    getBomWorkshopFindList () {
      this.workshopCodeList = []
      if (this.formData?.orgNos?.length < 1) {
        return false
      }
      apiBomWorkshopFindList({ organizationCode: this.formData.orgNos }).then(res => {
        this.workshopCodeList = res
      })
    },
    show (query) {
      this.workshopCodeList = []
      this.loading = false
      this.$set(this.formData, 'orgNos', query?.orgNo ? [query.orgNo] : undefined)
      this.$set(this.formData, 'workshopCodes', query?.workshopCodes ? query.workshopCodes : undefined)
      if(this.formData?.orgNos) { this.getBomWorkshopFindList() }
      this.modal = true
    },
    submit () {
      this.$refs.form.validate(valid => {
        if(valid) {
          this.loading = true
          // 排产接口
          productionSchedulingPc({ orgNos: this.formData.orgNos }).then(res => {
            if (res.code === 200) {
              this.$message.success(res.msg)
              this.modal = false
            } else {
              this.$message.error(res.msg)
            }
          }).finally(() => {
            this.loading = false
          })
        }
      })
    }
  }
}
</script>

<style scoped>

</style>
